module.exports = __webpack_public_path__ + "static/media/familia1.8a42c8ac.jpg";